import React from "react";
import { Link } from "react-router-dom";
import "../css/Home.css";
import Disclaimer from "./Disclaimer";

const Home = () => {
  return (
    <div className="Home">
      <h3 className="mt-4">Welcome to your Connection Builder Toolkit!</h3>

      <p>
        Below you will find tools to help you build responses depending on the
        situation in which you may find yourself.
        <br></br>
      </p>

      <Disclaimer />

      <div
        class="btn-group m-4 home-page-btns"
        role="group"
        aria-label="Basic example"
      >
        <Link to="/connection-builder">
          <button type="button" className="btn btn-info">
            Build A Conflict Response 🔗
            <br></br>
            🟢
          </button>
        </Link>
        <Link to="/">
          <button type="button" className="btn btn-success" disabled>
            Create Praise/Compliment 🎉
            <br></br>
            🚧
          </button>
        </Link>
        <Link to="/">
          <button type="button" className="btn btn-warning" disabled>
            Build an Apology ❤️‍🩹
            <br></br>
            🚧
          </button>
        </Link>
        <Link to="/">
          <button type="button" className="btn btn-primary" disabled>
            Self-Care Next Steps 💛
            <br></br>
            🚧
          </button>
        </Link>
      </div>

      <p>Thank you for choosing connection.</p>
    </div>
  );
};

export default Home;
